import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const NotFound: FC<{}> = () => {
    const { t } = useTranslation(['common']);

    return (
        <div className="home_bg padding-40">
            <div className="error-page">
                <h2 className="error-page__title">{t('notFound.title', { ns: 'common' })}</h2>
                <p>{t('notFound.info', { ns: 'common' })}</p>
            </div>
        </div>
    );
}

export default NotFound;
